import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import RadioCheck from '../RadioCheck';
import type { RadioCheckProps } from '../RadioCheck';
import type { RefElement } from '../../types';
import { useTestIds } from '../../hooks';
import { withTestIds } from '../../utils';

import { getCheckboxTestIds } from './Checkbox.test-ids';

// Use Omit here to avoid listing all props for HTMLInputElement.
// eslint-disable-next-line @typescript-eslint/ban-types
export type CheckboxProps = Omit<RadioCheckProps, 'type'>;

const Checkbox = forwardRef<RefElement<CheckboxProps>, PropsWithoutRef<CheckboxProps>>(
  function Checkbox({ testId, ...restProps }, ref) {
    const testIds = useTestIds(testId, getCheckboxTestIds);

    return <RadioCheck {...restProps} testId={testIds} type='checkbox' ref={ref} />;
  }
);

export default withTestIds(Checkbox, getCheckboxTestIds);
